import React from "react";
import {
    Button,
    FoodInput,
    FormContainer,
    HeaderContainer,
    MainHeader,
    Select,
} from "./HeaderStyles";

const Header = ({ setQuery, setMealType, getData }) => {
    const handleSubmit = (e) => {
        e.preventDefault();
        // Call getData when form is submitted
        getData();
    };

    return (
        <HeaderContainer>
            <MainHeader>RECIPE APP</MainHeader>
            <FormContainer onSubmit={handleSubmit}>
                <FoodInput
                    type="text"
                    placeholder="Search"
                    onChange={(e) => setQuery(e.target.value)}
                />
                <Button type="submit">Search</Button>

                <Select
                    name="mealTypes"
                    id="mealTypes"
                    onChange={(e) => setMealType(e.target.value)}
                >
                    <option>Breakfast</option>
                    <option>Lunch</option>
                    <option>TeaTime</option>
                    <option>Dinner</option>
                </Select>
            </FormContainer>
        </HeaderContainer>
    );
};

export default Header;
